import { Component, OnInit } from '@angular/core';
import { Version } from './version.model';
import { VersionService } from './version.service';
import { environment } from '@env/environment';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {

  version: Version;

  constructor(
    private versionService: VersionService,
    private activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {
    this.versionService.getVersion().subscribe(
      (version: Version) => {
        this.version = version;
        this.version.app = environment.version;
      }
    );
  }

  public close(): void {
    this.activeModal.close();
  }

}
